import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-aiss-sso-forgot-password',
  templateUrl: './aiss-sso-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './aiss-sso-forgot-password.component.css',
  ],
})
export class HicreaSsoForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
